import axios from 'axios'
let token = localStorage.getItem('token')
axios.defaults.baseURL = process.env.VUE_APP_BASEURL;
axios.defaults.headers.common = {
  "Authorization": "Bearer "+token,
  "Accept" : 'application/json'
};
axios.interceptors.response.use(response => {
  return response;
}, error => {
 if (error.response.status === 401) {
  localStorage.removeItem('token')
  localStorage.removeItem('user_name')
  localStorage.removeItem('user_id')
  localStorage.removeItem('company_data');
  localStorage.removeItem('is_from_project');
  localStorage.removeItem('is_from_dashboard');
  localStorage.removeItem('co_group_id');
  localStorage.removeItem('co_item_id');
  localStorage.removeItem('co_project_id');
  localStorage.removeItem('co_co_id');
  localStorage.removeItem('redirect_to');
  window.location = '/'
 }
 return error;
});
export default axios